/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GuestAuthenticationEnum = core.serialization.enum_(["shared_link", "magic_link"]);
